import { render, staticRenderFns } from "./salesCommoditySingle.vue?vue&type=template&id=414132a3&scoped=true&"
import script from "./salesCommoditySingle.vue?vue&type=script&lang=js&"
export * from "./salesCommoditySingle.vue?vue&type=script&lang=js&"
import style0 from "./salesCommoditySingle.vue?vue&type=style&index=0&id=414132a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414132a3",
  null
  
)

export default component.exports